var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"pravo__buttons__goBackButton",class:_vm.icon,attrs:{"to":_vm.href,"tag":"button"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }